<template>
  <v-app class="login">
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <ValidationObserver ref="validator">
          <v-card width="340px" class="form" align="center" elevation="20">
            <v-toolbar color="primary" flat >
              <v-toolbar-title class="title" style="width: 100%">
                <h3>Eliminar Cuenta</h3>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" class="mt-8">
                <ValidationProvider name="email" rules="required|email">
                  <v-text-field
                    slot-scope="{ errors }"
                    :error-messages="errors"
                    v-model="user.email"
                    :type="'email'"
                    name="input-10-1"
                    label="Email"
                    autocomplete="off"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                    @change="setValidationMessage('')"
                  ></v-text-field>
                </ValidationProvider>
                <v-alert v-if="validation_message !== ''" type="error">
                  {{ validation_message }}
                </v-alert>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="submit mt-4"
                block
                rounded
                elevation="0"
                color="error"
                @click="login"
                :loading="status == 'loading'"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </ValidationObserver>
      </v-row>
    </v-container>
    <DeleteConfirm
      :show="confirmDelete"
      :hide="hideConfirmDelete"
      :submit="confirmDeleteItem"
      title="Eliminar cuenta"
      description="¿Estas seguro que deseas eliminar esta cuenta?"
    />
  </v-app>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import DeleteConfirm from "@/components/Crud/Modals/Confirm";
import swal from "sweetalert";
export default {
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.status,
    }),
  },
  watch: {
    "user.email": {
      handler: function(val) {
        this.setValidationMessage("");
      },
    },
  },
  data: () => ({
    validation_message: "",
    confirmDelete: false,
    valid: false,
    user: {
      email: "",
    },
  }),
  methods: {
    async login() {
      const self = this;
      const valid = await this.$refs.validator.validate();
      self.setValidationMessage("");
      if (valid) this.confirmDelete = true;
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    hideConfirmDelete() {
      this.confirmDelete = false;
    },
    async confirmDeleteItem() {
      const self = this;
      self.$store
        .dispatch("Authenticate/deleteAccount", this.user)
        .then(() => {
          swal("Cuenta Eliminada", "Su cuenta ha sido eliminada", "success");
          this.user.email = "";
          self.confirmDelete = false;
        })
        .catch((error) => {
          self.setValidationMessage("Email Invalido");
          self.confirmDelete = false;
        });
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    DeleteConfirm,
  },
};
</script>
